console.log("PopClub 0.39.0");

// Parameters and keys
let key = document.cookie
    .split("; ")
    .find((row) => row.startsWith("_shopify_s="))
    ?.split("=")[1];
let parameters = "?shop=" + Shopify.shop + "&key=" + key;

// get available coins API
const brandAPI = `https://prodreplica.mypopcoins.com/api/get-brand?shop=${Shopify.shop}`;
const coinsAPI = `https://prodreplica.mypopcoins.com/api/get-available-coins${parameters}`;

// Popclub Elements
const loginFlag = document.querySelector("#pop-club-login-flag");
const redeemPrice = document.querySelector("#pop-club-redeem-price");
const dataRedeem = document.querySelector("#pop-club-data-redeem");
const popBalance = document.querySelector("#pop-club-data-coins");
// Popclub datas accessing from session storages
let popclubDatas = JSON.parse(sessionStorage.getItem("PopDatas"));

// Brand & fetch coin API Calls
const getBrandInfo = async () => {
    try {
        if (!popclubDatas) {
            const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins");
            popCoinCheckbox.forEach((el) => (el.checked = true));
            const [P1, P2] = await Promise.all([fetch(brandAPI), fetch(coinsAPI)]);
            const brand_data = await P1.json();
            const coin_data = await P2.json();
            const PopDatas = {
                redeemPrice: brand_data.issuance,
                dataRedeem: brand_data.redeem,
                programName: brand_data.loyalty_program_name,
                loginFlag: coin_data.success,
                popBalance: coin_data.coins,
            };
            redeemPrice.value = brand_data.issuance;
            dataRedeem.value = brand_data.redeem;
            loginFlag.value = coin_data.success;
            popBalance.value = coin_data.coins;
            sessionStorage.setItem("PopDatas", JSON.stringify(PopDatas));
            popclubDatas = JSON.parse(sessionStorage.getItem("PopDatas"));
        }
        PLPCoins();
        PDPEarnCall();
        bottomStrip();
        cartEarnCall();
        PDP_BuyNow(loginFlag.value);
        pdpCoinContextUpdate();
        // PDPCoinContext();
    } catch (err) {
        console.log(err);
    } finally {
        discount_clear();
    }
};
//Trigger API on Floater close
const closeTriggerAPI = async () => {
    try {
        const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins");
        popCoinCheckbox.forEach((el) => (el.checked = true));
        const [P1, P2] = await Promise.all([fetch(brandAPI), fetch(coinsAPI)]);
        const brand_data = await P1.json();
        const coin_data = await P2.json();
        const PopDatas = {
            redeemPrice: brand_data.issuance,
            dataRedeem: brand_data.redeem,
            programName: brand_data.loyalty_program_name,
            loginFlag: coin_data.success,
            popBalance: coin_data.coins,
        };
        redeemPrice.value = brand_data.issuance;
        dataRedeem.value = brand_data.redeem;
        loginFlag.value = coin_data.success;
        popBalance.value = coin_data.coins;
        sessionStorage.setItem("PopDatas", JSON.stringify(PopDatas));
        popclubDatas = JSON.parse(sessionStorage.getItem("PopDatas"));
        PLPCoins();
        PDPEarnCall();
        bottomStripClose();
        PDP_BuyNow(loginFlag.value);
        pdpCoinContextUpdate();
        // PDPCoinContext();
    } catch (err) {
        console.log(err);
    } finally {
        const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins");
        popCoinCheckbox.forEach((el) => (el.checked = true));
        cartEarnCall();
    }
};

// PLP Price listing
const PLPCoins = () => {
    const popClubListing = document.querySelectorAll(".pop-club-listing");
    if (popClubListing.length && popclubDatas.popBalance > 0) {
        popClubListing.forEach((el) => {
            let price = el.getAttribute("price");
            let redeemCoins = Math.round((popclubDatas.dataRedeem / 100) * price);
            if (
                redeemCoins > popclubDatas.popBalance &&
                popclubDatas.loginFlag == true
            )
                redeemCoins = popclubDatas.popBalance;
            if (redeemCoins > 0 && popclubDatas.loginFlag == true) {
                let redeemPrice = Math.round(price - redeemCoins);
                let popHTML =
                    "<p>or Rs. " +
                    redeemPrice.toLocaleString() +
                    " + <span class='pop-img'><img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png'> </span> " +
                    redeemCoins.toLocaleString() +
                    "</p>";
                el.innerHTML = popHTML;
            } else {
                let popHTML = "";
                el.innerHTML = popHTML;
            }
        });
    }
};

// PDP Earn Call
const PDPEarnCall = (value) => {
    const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
    const PDPMbl = document.querySelectorAll(".mbl-product");
    let PDPPrice = Math.floor(
        +PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price")
    );
    if (PDPPrice > 19) {
        let modulePrice = PDPPrice % 20;
        let PriceValue = PDPPrice - modulePrice;
        let PDPEarnCoin = Math.round((popclubDatas.redeemPrice / 100) * PriceValue);
        if (PDPEarnCoin > 0) {
            if (value) PDPEarnCoin = PDPEarnCoin * value;
            popHTML =
                "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png'> </span> " +
                PDPEarnCoin +
                " on this product</p>";
            let productIssuanceMsg = document.getElementById("product-issuance-msg");
            if (productIssuanceMsg) {
                if (screen.availWidth < 749) {
                    if (PDPMbl.length > 0) PDPMbl[PDPMbl.length - 1].innerHTML = popHTML;
                    PDPEarnDiv[PDPEarnDiv.length - 1].innerHTML = popHTML;
                } else {
                    PDPEarnDiv[PDPEarnDiv.length - 1].innerHTML = popHTML;
                }
            } else {
                if (screen.availWidth < 749) {
                    if (PDPMbl.length > 0)
                        PDPMbl[PDPMbl.length - 1].insertAdjacentHTML("afterbegin", popHTML);
                    PDPEarnDiv[PDPEarnDiv.length - 1].innerHTML = popHTML;
                } else {
                    PDPEarnDiv[PDPEarnDiv.length - 1].insertAdjacentHTML(
                        "afterbegin",
                        popHTML
                    );
                }
            }
        }
        PDPEarnDiv[PDPEarnDiv.length - 1]?.classList.remove("hidden");
    } else {
        PDPEarnDiv[PDPEarnDiv.length - 1]?.classList.add("hidden");
    }
};

// Bottom Bar
const bottomStrip = (btmcoins) => {
    const popClubStripe = document.getElementById(
        "pop-club-quick-buy-span-stripe"
    );
    //Logged In bottom strip
    if (popclubDatas.loginFlag == true && popclubDatas.popBalance > 0) {
        setTimeout(()=>{
          let bottomCoins = popclubDatas.popBalance;
          let popHTMLStripe =
            '<span class="saaki_royal border-right">' + popclubDatas.programName + '</span>Get upto '+ popclubDatas.redeemPrice+'% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' +
            bottomCoins +
            '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
        popClubStripe.innerHTML = popHTMLStripe;
        },2000)
    }

    //Zero balance bottom strip
    if (popclubDatas.loginFlag == true && popclubDatas.popBalance == 0) {
        setTimeout(()=>{
          let bottomCoins = popclubDatas.popBalance;
          let popHTMLStripe =
            '<div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' +
            bottomCoins +
            '</div>| Shop and Earn POPcoins <img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
        popClubStripe.innerHTML = popHTMLStripe;
        },2000)
    }

    //Non-logged bottom strip
      if (popclubDatas.loginFlag == false) {
        setTimeout(()=>{
          let popHTMLStripe = '<span class="saaki_royal border-right">' + popclubDatas.programName + '</span><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">Get upto '+popclubDatas.redeemPrice+'% Off using POPcoins<img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png"></span>';
          popClubStripe.innerHTML = popHTMLStripe;
        },2000)
    }
};
// Bottom Bar
const bottomStripClose = (btmcoins) => {
    const popClubStripe = document.getElementById(
        "pop-club-quick-buy-span-stripe"
    );
    //Logged In bottom strip
    if (popclubDatas.loginFlag == true && popclubDatas.popBalance > 0) {
          let bottomCoins = popclubDatas.popBalance;
          let popHTMLStripe =
            '<span class="saaki_royal border-right">' + popclubDatas.programName + '</span>Get upto '+ popclubDatas.redeemPrice+'% Off using <div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' +
            bottomCoins +
            '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
        popClubStripe.innerHTML = popHTMLStripe;
    }

    //Zero balance bottom strip
    if (popclubDatas.loginFlag == true && popclubDatas.popBalance == 0) {
          let bottomCoins = popclubDatas.popBalance;
          let popHTMLStripe =
            '<div class="popcoin_sec"><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">' +
            bottomCoins +
            '</div>| Shop and Earn POPcoins <img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png">';
        popClubStripe.innerHTML = popHTMLStripe;
    }

    //Non-logged bottom strip
      if (popclubDatas.loginFlag == false) {
          let popHTMLStripe = '<span class="saaki_royal border-right">' + popclubDatas.programName + '</span><img width="30" height="30" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png">Get upto '+popclubDatas.redeemPrice+'% Off using POPcoins<img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png"></span>';
          popClubStripe.innerHTML = popHTMLStripe;
    }
};
// PDP Qty Update
const PDPQtyUpdate = () => {
    let qty = document.querySelector("#product-quantity-input")?.value;
    const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
    let PDP_Price = Math.floor(
        +PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price")
    );
    let PDPQtyVal = Math.round(PDP_Price * qty);
    let PDPUpdatedVal = Math.round((popclubDatas.dataRedeem / 100) * PDPQtyVal);
    PDPEarnCall(qty);
    bottomStrip(PDPUpdatedVal);
    // PDPCoinContext(PDPUpdatedVal);
};

// PDP Variant update
const PDP_PriceContainer = document.querySelector("product-price");
const configs = {
    childList: true, // observe direct children
    subtree: true, // and lower descendants too
    characterDataOldValue: true, // pass old data to callback
};
let observer = new MutationObserver(PDP_VariantChange); //Mutation observer for Price change
if (PDP_PriceContainer) observer.observe(PDP_PriceContainer, configs);

function PDP_VariantChange() {
    let PDP_input_elm = 1;
    let VariantPrice = document.querySelector(".\\#product-meta-price .\\#price-value")?.innerHTML.split("Rs.")[1].trim();
    if (VariantPrice.includes(",")) VariantPrice = VariantPrice.replace(",", "");
    const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
    PDPEarnDiv[PDPEarnDiv.length - 1]?.setAttribute("price", VariantPrice);
    let PDP_Price = Math.floor(
        +PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price")
    );
    let PDPQtyVal = Math.round(PDP_Price * PDP_input_elm);
    let PDPUpdatedVal = Math.round((popclubDatas.dataRedeem / 100) * PDPQtyVal);
    PDPEarnCall(PDP_input_elm);
    pdpCoinContextUpdate();
}

//Quick view PDP variant update
function quickVwVariantUpdate() {
    const quickPrice = document.querySelectorAll(
        ".quick-buy-modal__info-wrapper"
    );
    let VariantPrice = quickPrice[quickPrice.length - 1]
        ?.querySelector(".money")
        .innerHTML.split("Rs.")[1];
    if (VariantPrice.includes(",")) VariantPrice = VariantPrice.replace(",", "");
    const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
    PDPEarnDiv[PDPEarnDiv.length - 1]?.setAttribute("price", VariantPrice);
    let PDP_Price = Math.floor(
        +PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price")
    );
    let qty = 1;
    let PDPQtyVal = Math.round(PDP_Price * qty);
    let PDPUpdatedVal = Math.round((popclubDatas.dataRedeem / 100) * PDPQtyVal);
    PDPEarnCall(qty);
    bottomStrip(PDPUpdatedVal);
    // PDPCoinContext(PDPUpdatedVal);
}
// PDP Coin context for 3rd party checkout
const PDPCoinContext = (btmcoins) => {
    const pdpLabel = document.querySelectorAll("#buy-with-pop-coins-disc-label");
    const PDPEarnDiv = document.querySelectorAll("#pop-club-product-detail");
    const pdpCheckbox = document.querySelector("#buy-with-pop-coins-disc");
    if (popclubDatas.loginFlag == true && popclubDatas.popBalance > 0) {
        let PDP_redeemCoins = btmcoins;
        if (!btmcoins) {
            let PDP_Price = Math.floor(
                +PDPEarnDiv[PDPEarnDiv.length - 1]?.getAttribute("price")
            );
            PDP_redeemCoins = Math.round((popclubDatas.dataRedeem / 100) * PDP_Price);
        }
        if (
            (PDP_redeemCoins > popclubDatas.popBalance &&
                popclubDatas.loginFlag == true) ||
            PDP_redeemCoins == 0 ||
            isNaN(PDP_redeemCoins)
        )
            PDP_redeemCoins = popclubDatas.popBalance;
        console.log(PDP_redeemCoins);
        let popHTMLStripe = pdpCheckbox[0]?.checked ?
            `Rs.${PDP_redeemCoins}| Saved using POPcoins` :
            `Save Rs.${PDP_redeemCoins} using POPcoins`;
        // pdpLabel.forEach(el=>el.innerHTML=popHTMLStripe);
        pdpLabel[pdpLabel.length - 1].innerHTML = popHTMLStripe;
        console.log(popHTMLStripe);
        const PDP_Coin_wrapper = document.querySelector(".PDP_disc-wrapper");
        if (PDP_Coin_wrapper) PDP_Coin_wrapper.classList.remove("hidden");
    }
};
//PDP coin context update
function pdpCoinContextUpdate(mutation) {
    if (popclubDatas.loginFlag) {
        const pdpPriceElem = document.querySelectorAll("#pop-club-product-detail");
        const pdpcoinWrapper = document.querySelectorAll(".PDP_disc-wrapper");
        const redeemValue = document.querySelector("#pop-club-data-redeem");
        let pdpPrice = pdpPriceElem[pdpPriceElem.length - 1]?.getAttribute("price");
        let totalPrice = mutation ?
            Math.floor(pdpPrice * mutation[0].target.value) :
            Math.floor(pdpPrice * 1);
        let issueCoins = Math.round((popclubDatas.dataRedeem / 100) * totalPrice);
        const pdpCoinLabel = document.querySelectorAll(
            "#buy-with-pop-coins-disc-label"
        );
        const pdpCoinCheckbox = document.querySelectorAll(
            "#buy-with-pop-coins-disc"
        );
        if (issueCoins > popclubDatas.popBalance)
            issueCoins = popclubDatas.popBalance;
        if (issueCoins > 0) {
            if (pdpCoinCheckbox.length > 0)
                pdpCoinCheckbox[pdpCoinCheckbox.length - 1].checked = false;
            if (pdpCoinLabel.length > 0)
                pdpCoinLabel[
                    pdpCoinLabel.length - 1
                ].innerHTML = `Save Rs.${issueCoins} using POPcoins`;
            if (pdpcoinWrapper.length > 0)
                pdpcoinWrapper[pdpcoinWrapper.length - 1].classList.remove("hidden");
        }
    }
    discount_clear();
}
// PDP Buy Now button
const PDP_BuyNow = (loggedIn = false) => {
    const defaultBuyNowBtn = document.querySelectorAll("#default_buy_now");
    const PopBuyNowBtn = document.querySelectorAll(
        "#shopify-payment-button-popapp"
    );
    if (loggedIn == "true") {
        defaultBuyNowBtn.forEach((el) => el.classList.add("hidden"));
        PopBuyNowBtn.forEach((el) => el.classList.remove("hidden"));
    } else {
        defaultBuyNowBtn.forEach((el) => el.classList.remove("hidden"));
        PopBuyNowBtn.forEach((el) => el.classList.add("hidden"));
    }
};

//Third party buy now button functionality
const customBuyNowCheckout = async (e) => {
    try {
        const wrapperElem = e.target.closest(".\\#product-meta-inner");
        const checkboxElem = wrapperElem?.querySelector("#pop-club-product-detail");
        const PDPPrice = checkboxElem.getAttribute("price");
        let quantity = wrapperElem.querySelector('[name="quantity"]');
        let finalPDPPrice = +PDPPrice * 1;
        const variantId = wrapperElem?.querySelector("#pop-club-product-id");
        const buyNowparam = `?cart=${finalPDPPrice}&shop=${Shopify.shop}&key=${key}&variants=${variantId.value}`;
        const buyNowUrl = `https://prodreplica.mypopcoins.com/api/get-coins-cart-discount${buyNowparam}`;
        const resp = await fetch(buyNowUrl);
        const data = await resp.json();
        let now = new Date();
        let time = now.getTime();
        time += 3600 * 1000;
        now.setTime(time);
        document.cookie = `discount_code=${
      data.code
    };expires=${now.toUTCString()};path=/`;
    } catch (err) {
        console.log(err);
    } finally {
        let buyNowBtn = document.querySelectorAll(
            ".shopify-payment-button__button"
        );
        buyNowBtn.forEach((el) => {
            el.removeAttribute("disabled", "true");
        });
    }
};

// Cart third party checkout
const customCartCheckout = async () => {
    try {
        const resp = await fetch(window.Shopify.routes.root + "cart.js");
        const data = await resp.json();
        let priceLength = data["items_subtotal_price"].toString().length - 2;
        let price =
            data["items_subtotal_price"].toString().slice(0, priceLength) +
            "." +
            data["items_subtotal_price"].toString().slice(priceLength);
        let variants = "";
        for (let i = 0; i < data["items"].length; i++) {
            variants +=
                data["items"][i]["variant_id"] +
                "-" +
                data["items"][i]["quantity"] +
                ",";
        }
        let cartParams = `?cart=${price}&shop=${Shopify.shop}&key=${key}&variants=${variants}`;
        if (price > 0) {
            const cartUrl = `https://prodreplica.mypopcoins.com/api/get-coins-cart-discount${cartParams}`;
            const pop_resp = await fetch(cartUrl);
            const pop_data = await pop_resp.json();
            let now = new Date();
            let time = now.getTime();
            time += 3600 * 1000;
            now.setTime(time);
            document.cookie = `discount_code=${
        pop_data.code
      };expires=${now.toUTCString()};path=/`;
        }
    } catch (err) {
        console.log(err);
    } finally {
        document.querySelectorAll('[name="checkout"]').forEach(el => el.removeAttribute("disabled"));
    }
};
let cartDiscout;

function cartDiscoutAPI() {
    clearTimeout(cartDiscout);
    cartDiscout = setTimeout(() => {
        customCartCheckout();
    }, 1000);
}
//Enable PDP Buy now

function PDPBuyNow(e) {
    const PDP_label = e.target.closest(".\\#product-meta-inner").querySelector("#buy-with-pop-coins-disc-label");
    let buyNowBtn = document.querySelectorAll(".shopify-payment-button__button");
    buyNowBtn.forEach((el) => {
        el.setAttribute("disabled", "true");
    });
    const value_arr = PDP_label.innerHTML.split(" ");
    if (e.target.checked) {
        customBuyNowCheckout(e);
        PDP_label.innerHTML = `${value_arr[1]} | Saved using POPcoins`;
    } else {
        discount_clear();
        PDP_label.innerHTML = `Save ${value_arr[0]} using POPcoins`;
    }
}

//Clear discounts from cookies
const discount_clear = () => {
    document.cookie =
        "discount_code=; expires=Thu, 18 Dec 2020 12:00:00 UTC; path=/";
    let buyNowBtn = document.querySelectorAll(".shopify-payment-button__button");
    buyNowBtn.forEach((el) => {
        el.removeAttribute("disabled", "true");
    });
    document.querySelectorAll('[name="checkout"]').forEach(el => el.removeAttribute("disabled", "true"));
};
//Calculating cart value
const popSubtotal = async (data) => {
    let popHTML = "Calculating your total cart value";
    const popCoinLabel = document.querySelectorAll("#buy-with-pop-coins-label");
    const popCoinCheckbox = document.querySelectorAll("#buy-with-pop-coins");
    const subtotalValue = document.querySelectorAll(".totals__subtotal-value");
    if (popclubDatas.loginFlag == true) {
        let priceLength = data["items_subtotal_price"].toString().length - 2;
        let price = data["items_subtotal_price"].toString().slice(0, priceLength);
        let redeemCoins = Math.round((popclubDatas.dataRedeem / 100) * price);
        if (redeemCoins > popclubDatas.popBalance && popclubDatas.loginFlag == true)
            redeemCoins = popclubDatas.popBalance;
        let redeemPrice = Math.round(price - redeemCoins);
        let totalPrice = `${redeemPrice.toLocaleString()}.00`;
        let cartPrice = `${price.toLocaleString()}.00`;
        if (redeemCoins == 0) {
            // if(popBalance.value>0)debounceSearch();
            popCoinCheckbox.forEach((el) => el.classList.add("hidden"));
            popCoinCheckbox.forEach((el) => (el.checked = false));
            popHTML = "You have 0 POPcoins. Shop now & earn coins";
            subtotalValue.forEach((el) => (el.innerHTML = `Rs.${totalPrice}`));
            if (popclubDatas.popBalance > 0) {
                popHTML = "Calculating your total cart value";
            }
        } else {
            if (popCoinCheckbox[0]?.checked) {
                document.querySelectorAll('[name="checkout"]').forEach(el => el.setAttribute("disabled", "true"));
                cartDiscoutAPI();
            }
            popCoinCheckbox[0]?.checked ?
                (popHTML = `Rs. ${redeemCoins} | Saved using POPcoins`) :
                (popHTML = `Save Rs. ${redeemCoins} using POPcoins`);
            popCoinCheckbox[0]?.checked ?
                subtotalValue.forEach((el) => (el.innerHTML = `Rs. ${totalPrice}`)) :
                subtotalValue.forEach((el) => (el.innerHTML = `Rs. ${cartPrice}`));
            popCoinCheckbox.forEach((el) => el.classList.remove("hidden"));
            popCoinLabel.forEach((el) => (el.classList.add("bold")));
        }
    } else {
        popCoinCheckbox.forEach((el) => el.classList.add("hidden"));
        popCoinCheckbox.forEach((el) => (el.checked = false));
        popHTML =
            '<span onclick="openModel()"><span class="underline-pop">Click</span> & get upto '+popclubDatas.redeemPrice+'% off using POPcoins</span>';
    }
    popCoinLabel.forEach((el) => (el.innerHTML = popHTML));
};

//Creating elem
function create(el) {
    var d = document;
    var element = d.createElement(el);
    element.classList.add("manual-class");
    return element;
}
let cartUpdate;

function debounceSearch() {
    clearTimeout(cartUpdate);
    cartUpdate = setTimeout(() => {
        updateCartDropdown();
    }, 1000);
}

//Cart Earn Call
const cartEarnCall = async () => {
    try {
        const CartItemList = document.querySelectorAll(
            "cart-items cart-item"
        );
        const mainCartItemList = document.querySelectorAll(".page-cart .CartItem");

        function insertAfter(newNode, existingNode) {
            //Creates Earn call elem
            return new Promise((res, rej) => {
                res(
                    existingNode.parentNode.insertBefore(
                        newNode,
                        existingNode.nextSibling
                    )
                );
            });
        }
        const resp = await fetch(window.Shopify.routes.root + "cart.js");
        var data = await resp.json();
        let i = 0;
        var discountPrice = +data.total_discount;
        if (CartItemList.length > 0) {
            CartItemList.forEach((el) => {
                if (data["items"].length) {
                    let priceLength = data["items"][i].final_price.toString().length - 2;
                    let quantity = data["items"][i].quantity;
                    let price =
                        data["items"][i].final_price.toString().slice(0, priceLength) +
                        "." +
                        data["items"][i].price.toString().slice(priceLength);
                    if (price == ".0") {
                        let val = document
                            .querySelectorAll(".CartItem__Price")[i]?.textContent.split(",")
                            .join("")
                            .split(" ")[1];
                        price = val;
                        i++;
                    }
                    let priceValue = Math.floor(price);
                    let roundedPrice = 0;
                    if (priceValue.toString().length > 1) {
                        let modulePrice = priceValue % 20;
                        roundedPrice = priceValue - modulePrice;
                    }
                    let issueCoins = Math.round(
                        (popclubDatas.redeemPrice / 100) * roundedPrice * quantity
                    );
                    if (issueCoins > 0) {
                        let newstring =
                            "<p id='product-issuance-msg'> Earn <span class='pop-img'> <img src='https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/Coin.png' width='18' height='18'> </span> " +
                            issueCoins +
                            "</p>";
                        if (
                            el.querySelector(".\\#cart-item-card .manual-class") !=
                            null
                        ) {
                            el.querySelectorAll(".manual-class").forEach((old_item) => {
                                old_item.remove();
                            });
                        }
                        const ex = el.querySelector(
                            ".\\#cart-item-card .\\#cart-item-title"
                        );
                        if (ex) {
                            insertAfter(
                                create("div"),
                                el.querySelector(
                                    ".\\#cart-item-card .\\#cart-item-title"
                                )
                            ).then(() => {
                                el.querySelector(
                                    ".\\#cart-item-card .manual-class"
                                ).innerHTML = newstring;
                            });
                        }
                    }
                    i++;
                }
            });
        }
    } catch (err) {
        console.log(err);
    } finally {
        popSubtotal(data);
    }
};

//Updating Cart discount
const updatePopPrice = (e) => {
    const checkbox = document.querySelectorAll("#buy-with-pop-coins");
    checkbox.forEach((el) => (el.checked = e.target.checked));
    document.querySelectorAll('[name="checkout"]').forEach(el => el.setAttribute("disabled", "true"));
    cartEarnCall();
    if (e.target.checked) {
        customCartCheckout();
    } else {
        discount_clear();
        removeDiscount();
    }
};
// Cart Default checkout
const cartPopCheckout = async (e) => {
    const checkbox = document.querySelector("#buy-with-pop-coins");
    if (checkbox.checked) {
        e.preventDefault();
        try {
            const resp = await fetch(window.Shopify.routes.root + "cart.js");
            const data = await resp.json();
            let priceLength = data["items_subtotal_price"].toString().length - 2;
            let price =
                data["items_subtotal_price"].toString().slice(0, priceLength) +
                "." +
                data["items_subtotal_price"].toString().slice(priceLength);
            let variants = "";
            for (let i = 0; i < data["items"].length; i++) {
                variants +=
                    data["items"][i]["variant_id"] +
                    "-" +
                    data["items"][i]["quantity"] +
                    ",";
            }
            let cartParams = `?cart=${price}&shop=${Shopify.shop}&key=${key}&variants=${variants}`;
            const cartUrl = `https://prodreplica.mypopcoins.com/api/get-coins-cart${cartParams}`;
            const pop_resp = await fetch(cartUrl);
            const pop_data = await pop_resp.json();
            pop_data.success == true ? (window.location = pop_data.url) : openModel();
        } catch (err) {
            console.log(err);
        }
    } else {
        window.location.href = "/checkout";
    }
};
// Cart Analytics
async function cartSession() {
    try {
        const cookies = document.cookie.split("; ").reduce((cookieObj, cookie) => {
            const [name, value] = cookie.split("=");
            cookieObj[name] = value;
            return cookieObj;
        }, {});

        const sessionKey = cookies["_popcoin_session"];

        if (sessionKey) {
            console.log("Cookies available");
            return;
        }

        console.log("Cookies not available");
        const keySession = cookies["_shopify_s"];

        if (!keySession) {
            console.log("Cookies null or undefined");
            return;
        }

        console.log("Cookies not available & generated");
        const now = new Date();
        const expirationTime = 1 * 60 * 60 * 1000; // 1 hour in milliseconds
        now.setTime(now.getTime() + expirationTime);

        const session_value = "first";
        document.cookie = `_popcoin_session=${session_value}; expires=${now.toUTCString()}; path=/`;
        console.log(Shopify.shop);

        const response = await fetch(
            `https://prodreplica.mypopcoins.com/api/get/active/sessions?session_id=${keySession}&shop=${Shopify.shop}`
        );

        if (response.ok) {
            const sessionData = await response.json();
            console.log(sessionData);
        } else {
            throw new Error(
                `Failed to fetch session data: ${response.status} ${response.statusText}`
            );
        }
    } catch (error) {
        console.error("Error in cartSession:", error);
    }
}
//Remove_discount
function removeDiscount() {
    fetch(
            "https://prodreplica.mypopcoins.com/api/remove-discount-code" + parameters
        )
        .then((response) => response.json())
        .then((data) => {
            if (data.success) {
                console.log("discount_deleted");
            }
        });
}
//Open loaded iframe
function openModel() {
    let modal = document.getElementById("myModal3");
    modal.style.display = "block";
    document.body.classList.add("popcoinShow");
    const ajaxCart = document.querySelector(".drawer");
    if (ajaxCart) ajaxCart.style.zIndex = 995;
}

function hideBtmstrip() {
    const btmstrip = document.querySelector(".back-to-top1");
    btmstrip?.classList.add("hidden");
    if (window.location.href.indexOf("/cart") == -1) discount_clear();
    const cartCheckbox = document.querySelector("#buy-with-pop-coins");
    const PDPCheckbox = document.querySelector("#buy-with-pop-coins-disc");
    if (cartCheckbox) cartCheckbox.checked = true;
    if (PDPCheckbox && PDPCheckbox.checked) {
        PDPCheckbox.checked = false;
        const PDP_label = document.querySelector("#buy-with-pop-coins-disc-label");
        const value_arr = PDP_label.innerHTML.split(" ");
        PDP_label.innerHTML = `Save ${value_arr[0]} using POPcoins`;
    }
    cartEarnCall();
    const cartDrawer = document.querySelector("body");
    if (cartDrawer.classList.contains("active-cart")) load_iframe(true);
}

function showBtmstrip() {
  discount_clear();
  const btmstrip = document.querySelector(".back-to-top1");
  btmstrip?.classList.remove("hidden");
}
//iframe source tracker
function load_iframe(isCart = false) {
    let popclub_iframe_src;
    const key = document.cookie
        .split("; ")
        .find((row) => row.startsWith("_shopify_s="))
        ?.split("=")[1];
    const iframeURL = document.querySelector("#pop-club-iframe-url").value;

    if (window.location.href.indexOf("/products/") != -1) {
        let redeemCoins = document.querySelector("#pop-club-redeem-price").value;
        popclub_iframe_src =
            iframeURL + "&key=" + key + "&page=pdp&discount=" + redeemCoins;
    } else {
        let cartPage = "";
        if (window.location.href.indexOf("/cart") != -1) {
            cartPage = "&page=cart";
        }
        popclub_iframe_src = iframeURL + "&key=" + key + cartPage;
    }
    console.log(
        popclub_iframe_src +
        "&url=" +
        window.location.href +
        (isCart ? "-cart" : "")
    );
    document.querySelector("#popupiframe1").src =
        popclub_iframe_src +
        "&url=" +
        window.location.href +
        (isCart ? "-cart" : "");
}

function menuIframeOpen() {
    let queryString = window.location.search;
    if (
        queryString.includes("coins=true") ||
        queryString.includes("coins=TRUE")
    ) {
        preLoadIframe();
        openModel();
    }
}
// Cart Analytics
async function cartTokenGenerate() {
    try {
        let cartData = await fetch("/cart.js");
        cartData = await cartData.json();
        if (cartData.items.length === 0) {
            await fetch("/cart/clear");
            let cartToken = await fetch("/cart.js");
            cartToken = await cartToken.json();
            sessionStorage.setItem("cartTokenGenerated", "true");
            sessionStorage.setItem("popClubSession", cartToken.token);
        } else if (sessionStorage.getItem("popClubSession") === null) {
            let cartToken = await fetch("/cart.js");
            cartToken = await cartToken.json();
            sessionStorage.setItem("cartTokenGenerated", "true");
            sessionStorage.setItem("popClubSession", cartToken.token);
        }
    } catch (error) {
        console.error("An error occurred:", error);
    }
}
/* Hide pdpCoin context */
function hideCoinContext(t){
  setTimeout(()=>{
     const pdpwrapper = document.querySelector(".pdp-pop-container");
            if (pdpwrapper && t.variant.available) {
                pdpwrapper.classList.remove("hidden")
            } else {
                pdpwrapper.classList.add("hidden")
            }
  },1000)
}
/* preload iframe */
function preLoadIframe() {
    let popclub_iframe_src;
    let modals = document.getElementById("myModal3");
    modals.style.opacity = 1;
    document.body.classList.add("popcoinShow");
    const iframeURL = document.querySelector("#pop-club-iframe-url").value;
    if (window.location.href.indexOf("/products/") != -1) {
        const redeemCoins = document.querySelector("#pop-club-redeem-price").value;
        popclub_iframe_src =
            iframeURL + "&key=" + key + "&page=pdp&discount=" + redeemCoins;
    } else {
        let cartPage = "";
        if (window.location.href.indexOf("/cart") != -1) {
            cartPage = "&page=cart";
        }
        popclub_iframe_src = iframeURL + "&key=" + key + cartPage;
    }
    document.querySelector("#popupiframe1").src =
        popclub_iframe_src + "&url=" + window.location.href;
    console.log("iframe loaded");
    body.removeEventListener("mousemove", loadIframe);
    body.removeEventListener("touchstart", loadIframe);
}
const body = document.querySelector("body");

function loadIframe() {
    preLoadIframe();
    // const inputElemPDP=document.querySelector('[name="quantity"]')
    // if(inputElemPDP) inputElemPDP.value=1;
    const pdpCheckbox = document.querySelector("#buy-with-pop-coins-disc");
    if (pdpCheckbox) pdpCheckbox.checked = false;
    const cartCheckbox = document.querySelector("#buy-with-pop-coins");
    if (cartCheckbox && cartCheckbox.checked == false) {
        cartCheckbox.checked = true;
        cartEarnCall();
    }
    if (window.location.href.indexOf("/products") != -1) {
        pdpCoinContextUpdate();
        discount_clear();
        removeDiscount();
    }
    if (window.location.href.indexOf("/cart") == -1) {
        setTimeout(() => {
            discount_clear();
            removeDiscount();
        }, 3000)
    }
}
document.addEventListener("DOMContentLoaded", () => {
    menuIframeOpen();
    getBrandInfo();
    if (window.location.href.indexOf("/cart") == -1) {
        //show btmstrip
        const bottomstrip = document.querySelector(".back-to-top1");
        bottomstrip.classList.remove("hidden");
    }
    cartSession();
    cartTokenGenerate();
    if (window.location.href.indexOf("/products") != -1) {
        //Enable PLP Coins for Recommended products
        document.addEventListener("scroll", () => {
            PLPCoins();
        })
        setTimeout(() => pdpCoinContextUpdate(), 1000);
        const pdpCheckbox = document.querySelector("#buy-with-pop-coins-disc");
        if (pdpCheckbox) pdpCheckbox.checked = false;
        removeDiscount();
        discount_clear();
        setTimeout(() => PLPCoins(), 3000);
        const inputElemPDP = document.querySelector('[name="quantity"]');
        inputElemPDP?.addEventListener("change", () => {
            discount_clear();
            pdpCoinContextUpdate();
        });
    }
    if (window.location.href.indexOf("/cart") != -1) {
        //show btmstrip
        const cartCheckbox = document.querySelector("#buy-with-pop-coins");
        cartCheckbox.checked = true;
        cartEarnCall();
    }
});

body.addEventListener("mousemove", loadIframe);
body.addEventListener("touchstart", loadIframe);